import { TagColor } from "react-migration/components/Tag";
import { AddOn } from "./types";

import hometrackLogoSrc from "public/addons/hometrack/hometrack-logo@2x.png";
import landfundLogoSrc from "public/addons/landfund/landfund-logo@2x.png";
import giveMyViewLogoSrc from "public/addons/give-my-view/give-my-view-logo@2x.png";

export const HOMETRACK_ADDON: AddOn = {
  title: "Hometrack",
  subtitle: "by Zoopla",
  description:
    "Get ahead of the competition with market leading intelligence into local housing markets, enabling you to understand your potential future returns.",
  logoSrc: hometrackLogoSrc,
  tags: [
    { text: "Explore", color: TagColor.LIGHT_GRAY },
    { text: "Assessment", color: TagColor.LIGHT_GRAY },
    { text: "Subscription", color: TagColor.LIGHT_GRAY },
  ],
};

export const LANDFUND_ADDON: AddOn = {
  title: "LandFund",
  description:
    "LandFund is the tech-backed brokerage and appraisal tool you need to secure funding for your development, quickly.",
  logoSrc: landfundLogoSrc,
  tags: [
    { text: "Product", color: TagColor.LIGHT_GRAY },
    { text: "Subscription", color: TagColor.LIGHT_GRAY },
  ],
};

export const GIVE_MY_VIEW_ADDON: AddOn = {
  title: "Give My View",
  description: "Survey people digitally to increase diversity and completion rates for your community consultations",
  logoSrc: giveMyViewLogoSrc,
  tags: [
    { text: "Product", color: TagColor.LIGHT_GRAY },
    { text: "Subscription", color: TagColor.LIGHT_GRAY },
  ],
};
